import React from 'react'

const StatsCard = ({ title, value, icon: Icon, color = 'accent' }) => {
  const colorClasses = {
    accent: 'text-accent bg-blue-50',
    success: 'text-success bg-emerald-50',
    error: 'text-error bg-red-50',
    warning: 'text-warning bg-amber-50',
  }

  return (
    <div className="card">
      <div className="flex items-start justify-between">
        <div>
          <p className="text-text-muted text-xs font-medium uppercase tracking-wider">{title}</p>
          <p className="text-2xl font-bold text-text-primary mt-1">
            {typeof value === 'number' ? value.toLocaleString() : value}
          </p>
        </div>
        {Icon && (
          <div className={`w-9 h-9 rounded-lg flex items-center justify-center ${colorClasses[color] || colorClasses.accent}`}>
            <Icon size={18} />
          </div>
        )}
      </div>
    </div>
  )
}

export default StatsCard
